export default {
  // 超时
  timeout: 10000,
  baseURL: 'http://150.158.91.235:8001/',
  // baseURL: 'http://127.0.0.1:8001/',
  // baseURL: '/api',
  // 是否支持跨域
  crossDomain: true,
  // 跨域带上cookie
  withCredentials: true,
  // 请求头，默认是采用application/json
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
};
